<template>
  <div class="breadcrumbs-item results-link" @click="goBack()">
    <template v-if="$store.state.isApp && isHeader">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 13 21"
        width="13px"
        height="21px"
      >
        <path
          fill="#fff"
          fill-rule="evenodd"
          d="M9.90638279.9899495L0 10.5l9.90638279 9.5100505c.57620221.5531497 1.48620921.5531497 2.06241151 0 .546734-.5248604.564466-1.3935593.0396056-1.9402933a1.3722874 1.3722874 0 0 0-.0396056-.0396057L4.12482294 10.5l7.84397136-7.5301515c.546734-.5248604.564466-1.3935593.0396056-1.9402933a1.3722874 1.3722874 0 0 0-.0396056-.0396057c-.5762023-.5531497-1.4862093-.5531497-2.06241151 0z"
        />
      </svg>
    </template>

    <template v-else>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 13 21"
        width="13px"
        height="21px"
        class="breadcrumbs-arrow"
      >
        <path
          fill="#3F51AE"
          fill-rule="evenodd"
          d="M9.90638279.9899495L0 10.5l9.90638279 9.5100505c.57620221.5531497 1.48620921.5531497 2.06241151 0 .546734-.5248604.564466-1.3935593.0396056-1.9402933a1.3722874 1.3722874 0 0 0-.0396056-.0396057L4.12482294 10.5l7.84397136-7.5301515c.546734-.5248604.564466-1.3935593.0396056-1.9402933a1.3722874 1.3722874 0 0 0-.0396056-.0396057c-.5762023-.5531497-1.4862093-.5531497-2.06241151 0z"
        />
      </svg>
      <b class="mr" v-if="total">{{ total }}</b>
      <span style="white-space: nowrap;"> {{ title }}</span>
    </template>
  </div>
</template>

<script>
import urls from "@/mixins/newCars/urls";
import { mapMutations } from "vuex";

export default {
  props: {
    companyId: {
      type: [Number, String],
    },
    oldCars: {
      type: Boolean,
      default: false,
    },
    total: {
      default: null,
    },
    isHeader: Boolean
  },
  mixins: [urls],
  data: () => ({
    query_param: window.location.search,
  }),
  methods: {
    ...mapMutations({
      setData: "SET_DATA",
    }),
    goBack() {
      if (this.$router.history._startLocation === this.$route.fullPath) {
        this.$router.push(this.$route.fullPath.includes('notadir-bilar') ? '/notadir-bilar' : '/')
      } else {
        this.$router.back()
      }

      /*
      if(this.$route.name == 'k7Car'){
        //this.$router.push({name:'k7Cars'});
        //return;
      }
      const defaultFilters = {
        brands: [],
        brand_model: [],
        fuel_type: [],
        argerd: [1999, 2021],
        verd: [0, 20000000],
        ekinn: [0, 287000],
        girartegund: [],
        flokkar: [],
        other: [],
        vt: [],
        verdtilbod: false,
        category: [],
        sort: {
          field: "",
          order: "",
        },
        parking: false,
        companies: [],
      };

      this.setData({
        field: "scrollPositionPageOldCars",
        data: 0,
      });
      this.setData({
        field: "scrollPositionPageDealers",
        data: 0,
      });
      this.setData({
        field: "moduleOldCars.cars.scrollTop",
        data: 0,
      });

      this.setData({
        field: "moduleDealers.page",
        data: {},
      });
      this.setData({
        field: "moduleOldCars",
        data: {
          carLoaded: false,
          cars: {
            scrollTop: 0,
            filters: defaultFilters,
            items: [],
            loaded: false,
          },
        },
      });
      this.$router.push(this.link);
       */
    },

  },
  computed: {
    title() {
      if (this.$route.name == "DealerCar") {
        return "Nýir bílar";
      } else if (this.$route.name == "CarInStock") {
        return "Kjarabílar";
      } else if (this.$route.name == "Car") {
        return "Notaðir bílar";
      }
    },
    link() {
      let props = "";
      if (this.$route.name == "DealerCar") {
        props = this.$router.resolve({ name: "DealersCars" });
      } else if (this.$route.name == "CarInStock") {
        props = this.$router.resolve({ name: "CarsInStock" });
      } else if (this.$route.name == "k7Car") {
        props = this.$router.resolve({ name: "k7Cars" });
      } else if (this.$route.name == "Car") {
        props = this.$router.resolve({ name: "OldCars" });
      }

      let query = this.query_param;
      return `${props.href}/${query}`;
    },
  },
};
</script>
